import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Observable } from 'rxjs';

@Injectable()
export class DictionnaryService {
  url = 'traductions/'

  constructor(private _http: HttpClient, private kiwixiService: KiwixiService) { }

  getDictionnary2(_lang, _site?: string): Observable<any> {
    const site = _site || localStorage.getItem('site');
    const newBundle = { 'site': site, 'language': _lang };
    let httpHeader = new HttpHeaders()
    httpHeader = httpHeader.append('x-bundle-recurring', JSON.stringify(newBundle));
    // On passe aussi site/language en query params : ils sont prioritaires côté backend
    // et ne sont pas réécrits par l'AuthInterceptor (utile en mode impersonate).
    const url = environment.server + this.url
      + '?salt=' + Math.random().toString()
      + '&site=' + encodeURIComponent(site || '')
      + '&language=' + encodeURIComponent(_lang || '');
    return this._http.get<any>(url, {
      headers: httpHeader,
    })
      .pipe(
        catchError(this.kiwixiService.handleErrorObservable<any>(`getDictionnary`))
      );
  }
  getDictionnary(_lang) {
    // let's connect with minimal viable informations to get locale
    const site = localStorage.getItem('site');
    const newBundle = { 'site': site, 'language': _lang };
    let httpHeader = new HttpHeaders()
    httpHeader = httpHeader.append('x-bundle-recurring', JSON.stringify(newBundle));
    return this._http.get(environment.server + this.url, {
      headers: httpHeader,
    }).pipe(
      map(res => {
        const body = res;
        return body || {};
      })
    )
      .toPromise();
  }

  getTranslateLanguage() {
    return [
      {label: 'language.en', code: 'en'},
      {label: 'language.fr', code: 'fr'},
      {label: 'language.es', code: 'es'},
      {label: 'language.it', code: 'it'},
    ]
  }
}
